<template>
  <component
    :is="as"
    class="dropdown-container"
    @focusin="toggleMenuHandler(true)"
    @mouseenter="toggleMenuHandler(true)"
    @mouseleave="toggleMenuHandler(false)"
  >
    <slot name="trigger" />
    <div @click="toggleMenuHandler(false)">
      <slot v-if="isOpenMenu" name="menu" />
    </div>
    <slot />
    <!-- <slot name="menu" /> -->
  </component>
</template>

<script setup>
  import { ref } from 'vue'

  const emit = defineEmits(['toggle'])
  const props = defineProps({
    as: {
      type: String,
      default: 'div',
    },
  })
  const isOpenMenu = ref(false)

  const toggleMenuHandler = (status) => {
    isOpenMenu.value = status
    emit('toggle', status)
  }
</script>
<script>
  export default {
    name: 'WDropdown',
  }
</script>

<style lang="scss" scoped>
  .dropdown-container {
    position: relative;
  }
</style>
